import { ComponentProps, FC } from 'react'

import { useFragment } from '@apollo/client'
import { DetailsItemsList } from '@factorialco/f0-react/dist/experimental'
import DOMPurify from 'dompurify'
import { TrainingsTrainingRequestApprovableFragmentDoc } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { EmployeeTableViewRow } from 'modules/inbox_tasks/activities/Task/utils/content'
import NoteField from 'modules/inbox_tasks/components/NoteField'

type TrainingsTrainingRequestTaskContentProps = {
  id: number
  requesterContent: EmployeeTableViewRow
}

const TrainingsTrainingRequestTaskContent: FC<TrainingsTrainingRequestTaskContentProps> = ({
  id,
  requesterContent,
}) => {
  const { data } = useFragment({
    fragment: TrainingsTrainingRequestApprovableFragmentDoc,
    fragmentName: 'TrainingsTrainingRequestApprovable',
    from: {
      __typename: 'TrainingsTrainingRequest',
      id,
    },
    optimistic: false,
  })

  if (!data) {
    return null
  }

  const details: ComponentProps<typeof DetailsItemsList>['details'] = [
    requesterContent,
    data.trainingName && {
      title: i18n.t('tasks.approvals.trainings_training_request.fields.training_name'),
      content: {
        text: data.trainingName,
        type: 'item' as const,
      },
    },
  ].filter(Boolean)

  const trainingNeedText = data?.trainingNeed
    ? DOMPurify.sanitize(data?.trainingNeed, { ALLOWED_TAGS: [] })
    : ''
  const trainingCommentText = data?.comments
    ? DOMPurify.sanitize(data?.comments, { ALLOWED_TAGS: [] })
    : ''

  return (
    <>
      <DetailsItemsList details={details} tableView />
      {!!trainingNeedText && (
        <NoteField
          label={i18n.t('tasks.approvals.trainings_training_request.fields.training_need')}
          content={trainingNeedText}
        />
      )}
      {!!trainingCommentText && (
        <NoteField
          label={i18n.t('tasks.approvals.trainings_training_request.fields.additional_info')}
          content={trainingCommentText}
        />
      )}
    </>
  )
}

export default TrainingsTrainingRequestTaskContent

export * from './metadata'
